import {
  useIsNotInReviewsHoldoutGroup,
  useReviewsHoldoutAssignSettingEffect,
} from "@faire/deprecated-retailer-visitor-shared/settings/useSettingReviewsHoldoutXP";
import { Row } from "@faire/web/slate/Layout";
import { LoadingSpinner } from "@faire/web/slate/LoadingSpinner";
import React from "react";
import styled from "styled-components";

import { IBrandReviewsListProps } from "./types";
import { LazyBrandReviewsListV1 } from "./V1/LazyBrandReviewsListV1";
import { LazyBrandReviewsListV2 } from "./V2/LazyBrandReviewsListV2";

export const LazyBrandReviewsList: React.FC<IBrandReviewsListProps> = (
  props
) => {
  useReviewsHoldoutAssignSettingEffect();

  const shouldDisplayV2ReviewsList = useIsNotInReviewsHoldoutGroup();

  if (shouldDisplayV2ReviewsList) {
    return <LazyBrandReviewsListV2 {...props} />;
  }
  return <LazyBrandReviewsListV1 {...props} />;
};

export const BrandReviewsFallback: React.FC = () => (
  <Wrapper>
    <LoadingSpinner />
  </Wrapper>
);

const Wrapper = styled(Row).attrs({
  align: "center",
  justify: "center",
})`
  height: 1000px;
`;
